import { styled } from "@mui/material";

export const ValueContainer = styled("div")(({ theme }) => ({
  marginLeft: "auto",
  textAlign: "right",
}));
